export { Icon } from './Icon.js';
export { iconMap } from './iconMap.js';
//# sourceMappingURL=index.js.map
